__turbopack_context__.v({
  "alphabetDisplay": "BrandTypography-module__lmFk8W__alphabetDisplay",
  "badgeLabel": "BrandTypography-module__lmFk8W__badgeLabel",
  "card": "BrandTypography-module__lmFk8W__card",
  "description": "BrandTypography-module__lmFk8W__description",
  "downloadBtn": "BrandTypography-module__lmFk8W__downloadBtn",
  "downloadBtnDisabled": "BrandTypography-module__lmFk8W__downloadBtnDisabled",
  "fontName": "BrandTypography-module__lmFk8W__fontName",
  "grid": "BrandTypography-module__lmFk8W__grid",
  "heading": "BrandTypography-module__lmFk8W__heading",
  "section": "BrandTypography-module__lmFk8W__section",
  "specimen": "BrandTypography-module__lmFk8W__specimen",
  "weight": "BrandTypography-module__lmFk8W__weight",
  "weightActive": "BrandTypography-module__lmFk8W__weightActive",
  "weightsRow": "BrandTypography-module__lmFk8W__weightsRow",
});
